var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.89475 4H24.1052C25.3684 4 26 4.52632 26 5.57896V22.421C26 23.4737 25.3684 24 24.1052 24H3.89475C2.63158 24 2 23.4737 2 22.421V5.57896C2 4.52632 2.63158 4 3.89475 4Z",
    fill: "#DBECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8077 13.8184L17.1915 21.7438L20.3834 16.9885L23.5753 22.0608H4.42383L10.8077 13.8184Z",
    fill: "#5096FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7578 9.69682C17.7578 10.3719 18.026 11.0194 18.5034 11.4967C18.9807 11.9741 19.6282 12.2423 20.3033 12.2423C20.9784 12.2423 21.6258 11.9741 22.1032 11.4967C22.5805 11.0194 22.8487 10.3719 22.8487 9.69682C22.8487 9.02173 22.5805 8.37428 22.1032 7.89691C21.6258 7.41955 20.9784 7.15137 20.3033 7.15137C19.6282 7.15137 18.9807 7.41955 18.5034 7.89691C18.026 8.37428 17.7578 9.02173 17.7578 9.69682Z",
    fill: "#FFD972"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImg);
export default __webpack_public_path__ + "static/media/icon_img.83e037cb57dd43e0523cfbd41da9ca18.svg";
export { ForwardRef as ReactComponent };